import React from 'react';

import { Box, useTheme } from '@mui/material';

import { AccordionSection } from '~/components/AccordionSection';
import { EimInput } from '~/components/EimInput';
import { IConfigurationOptionGroup } from '~/domain/IConfigurationOptionGroup';
import { IConfigurationRule } from '~/domain/IConfigurationRule';

import { ConfigurationOption } from './ConfigurationOption';

interface IVehicleConfigurations {
  eim: string;
  packSets: IConfigurationOptionGroup[],
  eimPackSets: IConfigurationOptionGroup[],
  rules: IConfigurationRule[],
  validatedPackSets: IConfigurationOptionGroup[],
  validatedEimPackSets: IConfigurationOptionGroup[],
  validatedMultiPackSets: IConfigurationOptionGroup[],
  validatedSinglePackSets: IConfigurationOptionGroup[],
}

export const VehicleConfigurations = React.memo<IVehicleConfigurations>(function VehicleConfigurations(props) {
  const {
    eim,
    eimPackSets,
    packSets,
    rules,
    validatedPackSets,
    validatedEimPackSets,
    validatedMultiPackSets,
    validatedSinglePackSets,
  } = props;

  const { palette } = useTheme();

  return (
    <>
      
      <>
        <Box
          sx={{
            position: 'sticky',
            width: '100%',
            pt: 2,
            pb: 3,
            top: 0,
            zIndex: 2,
            background: palette.background.paper,
            mt: 2,
          }}
        >
          <EimInput eimPackSets={eimPackSets} packSets={packSets} rules={rules} />
        </Box>
      </>
    
      <>
        <Box sx={{ overflow: 'auto' }}>
          <AccordionSection
            label={
              <>
                <span style={{ color: palette.primary.light, marginRight: 10 }}>
                  EIM:
                </span>
                {eim} 
              </>
            }
          >
            
            {validatedEimPackSets.map((packSet) => {
              return (
                <ConfigurationOption
                  key={packSet.code}
                  packSet={packSet}
                  packSets={validatedPackSets}
                  rules={rules}
                />
              );
            })}
          </AccordionSection>
          <AccordionSection label="Configuration Options" defaultExpanded>
            {validatedMultiPackSets.map((packSet) => {
              return (
                <ConfigurationOption
                  key={packSet.code}
                  packSet={packSet}
                  packSets={validatedPackSets}
                  rules={rules}
                />
              );
            })}
          </AccordionSection>
          <AccordionSection label="Non-Selectable Options">
            
            {validatedSinglePackSets.map((packSet) => {
              return (
                <ConfigurationOption
                  key={packSet.code}
                  packSet={packSet}
                  packSets={validatedPackSets}
                  rules={rules}
                />
              );
            })}
          </AccordionSection>
        </Box>
      </>
      
    </>
  );
});
